import React, { Component } from 'react';
import moment from 'moment';

import withAuthorization from '../components/withAuthorization';
import { db, realtimeDb, firebase, getUserNeighbourhoodLocation } from '../firebase/firebase';
import { auth } from '../firebase/index.js';

import Modal from 'react-modal';
import { showSnackbar, showSnackbarWithType, showSnackbarWithTimeout } from '../components/Snackbar.js';
import { Table } from 'element-react';
import 'element-theme-default';
import RoleUtils from '../utils/RoleUtils';
import { GeoFire } from 'geofire';
import AddMeldingMap from '../components/AddMeldingMap.js';

class Meldingen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logEntries: [],
            users: [],
            modalUpdateLogStatusIsOpen: false,
            showWerkgebiedenModal: false,
            postcodeLabelText: '',
            postcodeText: '',
            workareas: [],
            showMeldingenDetailsModal: false,
            selectedMelding: {
                id: null,
                timestamp: null,
                nearbyLocation: [51.3109043, 5.3322327],
                description: null,
                address: null,
                status: null,
                Subject: null,
                uid: null,
                updatedAt: null,
                postalCodes: []
            },
            newComment: '',
            lastSelectedMelding: null,
            newStatus: null,
            newCommentFrom: 'Wijkcoordinator',
            showAddMeldingModal: false,
            postalCodes: [],
            postalCodeInput: '',
            descriptionText: '',
            subjectText: '',
            location: null,
            addressText: '',
            mapLocation: null,
            categories: [
                { id: 1, name: "Bedreiging / intimidatie" },
                { id: 2, name: "Verdachte situatie" },
                { id: 3, name: "Inbraak / Overval" },
                { id: 4, name: "Diefstal" },
                { id: 5, name: "Geweld" },
                { id: 6, name: "Brand" },
                { id: 7, name: "Vandalisme / Vernieling" },
                { id: 8, name: "Gezocht" },
                { id: 9, name: "Vermist" },
            ],
            userData: null,
            columns: [
                {
                    label: "Adres",
                    prop: "address",
                    width: 150,
                    render: (data) => {
                        // split the adress on new line
                        if (data.address) {
                            const addressParts = data.address.split(', ');
                            return (
                                <div>
                                    {addressParts.map((part, index) => (
                                        <span key={index}>{part}<br /></span>
                                    ))}
                                </div>
                            );
                        }
                    }
                },
                {
                    label: "Onderwerp",
                    prop: "subject",
                    width: 150,
                },
                {
                    label: "Omschrijving",
                    prop: "description",
                    width: 140,
                    render: (data) => {
                        if (data.description) {

                            if (data.description.toLowerCase().includes('ondermijning')) {
                                return (
                                    <div>
                                        <span className={`badge badge-danger`}>
                                            ONDERMIJNING
                                        </span>
                                        <br />
                                        <em>Niet zichtbaar in app</em>
                                    </div>
                                );
                            }

                            let description = data.description;

                            if (description.split('.')[0].toLowerCase().includes('ter hoogte van')) {
                                description = description.split('.')[1];
                            }

                            return description.length > 50
                                ? description.substring(0, 50) + '...'
                                : description;
                        }
                    }
                },
                {
                    label: "Status",
                    prop: "status",
                    width: 90,
                    render: (data) => {
                        if (data.status) {
                            return (
                                <span className={`badge badge-${data.status === 'open' ? 'success' : 'warning'}`}>
                                    {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
                                </span>
                            );
                        }
                    }
                },
                {
                    label: "Datum",
                    prop: "timestamp",
                    width: 110,
                    render: (data) => {
                        if (data.timestamp) {
                            return typeof data.timestamp === 'number'
                                ? moment(data.timestamp).format("L[\n]HH:mm")
                                : moment(data.timestamp.toDate()).format("L[\n]HH:mm");
                        }

                    },
                    sortable: true,
                },
                {
                    label: "Laatste update",
                    prop: "updatedAt",
                    width: 110,
                    render: (data) => {
                        if (data.updatedAt) {
                            return typeof data.updatedAt === 'number'
                                ? moment(data.updatedAt).format("L[\n]HH:mm")
                                : moment(data.updatedAt.toDate()).format("L[\n]HH:mm");
                        }

                    },
                    sortable: true,
                },
                {
                    label: "Postcodes",
                    prop: "postalCodes",
                    width: 180,
                    render: (data) => {
                        if (data.postalCodes && data.postalCodes.length > 0) {
                            return data.postalCodes.map((code, index) => (
                                <span key={index} className="badge badge-secondary" style={{ marginRight: '5px' }}>
                                    {code}
                                </span>
                            ));
                        }
                        return '';
                    },
                },
                {
                    label: "Updates",
                    prop: "updates",
                    width: 100,
                    render: (data) => {
                        if (data.updates) {
                            return Object.keys(data.updates).length;
                        }
                    },
                },
                {
                    label: "Acties",
                    fixed: 'right',
                    width: 210,
                    render: (data) => {
                        if (data.status) {
                            return (
                                <div>
                                    {data.status !== 'open' ? (
                                        <button className="btn btn-warning" title="Open" data-toggle="tooltip"
                                            onClick={() => {
                                                this.openUpdateLogStatusModal(data, 'open');
                                            }}>Heropenen
                                        </button>
                                    ) : (
                                        <button className="btn btn-success" title="Gesloten" data-toggle="tooltip"
                                            onClick={() => {
                                                this.openUpdateLogStatusModal(data, 'gesloten');
                                            }}>Sluiten
                                        </button>
                                    )}
                                    <button type="button" className="btn btn-primary" title="Details bekijken"
                                        onClick={() => {
                                            localStorage.setItem('lastSelectedMelding', JSON.stringify(data));
                                            this.props.history.push({
                                                pathname: '/meldingen-details',
                                            });

                                        }} data-toggle="modal" data-target="#logModal">
                                        Bekijken
                                    </button>

                                    <button className="btn btn-danger" title="Verwijderen" data-toggle="tooltip"
                                        onClick={() => {
                                            this.openDeleteLogModal(data);
                                        }}>
                                        <i className="material-icons" title="Verwijderen" data-toggle="tooltip">delete_forever</i>
                                    </button>
                                </div>
                            )
                        }

                    }
                }
            ],
        };
        this.geofireListener = null;
        this.meldingenPostalcodesListener = null;
        this.meldingenListeners = new Map();
        this.meldingenPostalcodesListeners = new Map();
    }

    onPublicLogEntriesUpdate = querySnapshot => {
        let logEntries = [...this.state.logEntries];

        if (querySnapshot == null || querySnapshot.empty) {
            this.setState({ logEntries: [] });
            return;
        }

        const data = querySnapshot.val();

        if (logEntries.findIndex(item => item.id === querySnapshot.key) !== -1) {
            // Update existing log entry
            let index = logEntries.findIndex(item => item.id === querySnapshot.key);
            logEntries[index] = {
                id: querySnapshot.key,
                ...data
            };
        } else {
            logEntries.push({
                id: querySnapshot.key,
                ...data
            });
        }

        const sortedByDate = logEntries.sort((a, b) => {
            const dateA = a.timestamp ? (typeof a.timestamp === 'number' ? a.timestamp : a.timestamp.toDate().getTime()) : 0;
            const dateB = b.timestamp ? (typeof b.timestamp === 'number' ? b.timestamp : b.timestamp.toDate().getTime()) : 0;
            return dateB - dateA;
        });

        this.setState({ logEntries: sortedByDate });
    }

    componentDidMount() {
        this.getMyWorkareas();

        showSnackbarWithTimeout('Gegevens laden..', 1000);
    }

    getMyWorkareas = async () => {
        const userData = await auth.getUserData();
        const location = getUserNeighbourhoodLocation();
        this.setState({ userData, workareas: [], mapLocation: location });
        const workareasRef = realtimeDb.ref(`/workareas/${userData.uid}`);

        workareasRef.on('value', (snapshot) => {
            let workareas = snapshot.val();
            console.log('Fetched workareas:', workareas);

            if (!workareas) {
                workareas = [];
            } else {
                workareas.forEach(workarea => {
                    if (workarea.postcodes && workarea.postcodes.length > 0) {
                        workarea.postcodes.forEach(postcode => {
                            this.getPublicLogEntriesByPostalcode(postcode);
                        });
                    }
                });
            }

            this.setState({ workareas });
        });
    }

    componentWillUnmount() {
        this.meldingenListeners.forEach((value, key) => {
            this.removeMeldingListener(key);
        });
        this.meldingenPostalcodesListeners.forEach((listener, key) => {
            this.removeMeldingenPostalcodesListeners(key);
        });
    }

    getPublicLogEntriesByPostalcode = async (postcode) => {
        console.log('getPublicLogEntriesByPostalcode:', postcode);

        if (postcode.length === 4) {
            postcode = postcode + '_mk'; // for meldkamer
        }

        if (this.meldingenPostalcodesListeners.has(postcode)) {
            console.log('Already listening for postalcode:', postcode);
            return;
        }

        const meldingenPostalcodesListener = realtimeDb.ref(`/meldingen_by_postalcodes/${postcode}`);

        /*  postalcode
            "5571NX": {
                "melding1": true,
                "melding2": true
            },

            based on the postalcode, we can check which stored keys of meldingen are available and fetch them
        */

        meldingenPostalcodesListener.on('child_added', (snapshot) => {
            console.log('child_added:', snapshot.key, snapshot.val());
            this.addMeldingListener(snapshot.key);
        });
        meldingenPostalcodesListener.on('child_removed', (snapshot) => {
            console.log('child_removed:', snapshot.key, snapshot.val());
            this.removeMeldingListener(snapshot.key);
        });

        this.meldingenPostalcodesListeners.set(postcode, meldingenPostalcodesListener);
    }

    addMeldingListener = (key) => {
        if (this.meldingenListeners.has(key)) {
            return;
        }
        const meldRef = realtimeDb.ref(`/meldingen/${key}`);
        const listener = meldRef.on('value', snapshot => {
            this.onPublicLogEntriesUpdate(snapshot);
        });
        this.meldingenListeners.set(key, { ref: meldRef, listener });
    }

    removeMeldingListener = (key) => {
        if (this.meldingenListeners.has(key)) {
            const { ref, listener } = this.meldingenListeners.get(key);
            ref.off('value', listener);
            this.meldingenListeners.delete(key);
            let logEntries = this.state.logEntries.filter(item => item.id !== key);
            this.setState({ logEntries, filteredLogEntries: logEntries });
        }
    }

    removeMeldingenPostalcodesListeners = (key) => {
        if (this.meldingenPostalcodesListeners.has(key)) {
            const listener = this.meldingenPostalcodesListeners.get(key);
            listener.off();
            this.meldingenPostalcodesListeners.delete(key);
            console.log('Removed postalcode listener for:', key);
        }
    }

    openDeleteLogModal = (log) => {
        this.setState({ modalDeleteLogIsOpen: true, lastSelectedMelding: log });
    }

    closeDeleteLogModal = () => {
        this.setState({ modalDeleteLogIsOpen: false });
    }

    handleDeleteLogClicked = () => {
        this.closeDeleteLogModal();
        this.deleteLog();
    }

    deleteLog = () => {
        if (this.state.lastSelectedMelding && this.state.lastSelectedMelding.id) {
            realtimeDb.ref(`meldingen/${this.state.lastSelectedMelding.id}`).remove()
                .then(() => {
                    showSnackbar('Melding is verwijderd.');
                })
                .catch((error) => {
                    console.error("Error deleting document: ", error);
                    showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
                });

            let bulkRemove = {};
            this.state.lastSelectedMelding.postalCodes.forEach(postcode => {
                bulkRemove[`meldingen_by_postalcodes/${postcode}/${this.state.lastSelectedMelding.id}`] = null;
                bulkRemove[`meldingen_by_postalcodes/${postcode.substring(0, 4)}_mk/${this.state.lastSelectedMelding.id}`] = null;
            });

            bulkRemove[`chats/${this.state.lastSelectedMelding.id}`] = null;
            bulkRemove[`meldingen_locations/${this.state.lastSelectedMelding.id}`] = null;

            realtimeDb.ref().update(bulkRemove);

        } else {
            showSnackbarWithType('Geen melding geselecteerd om te verwijderen.', 'error');
        }
    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }

    deleteUpdateFromLogEntry = (updateId) => {
        const logEntry = this.state.lastSelectedMelding;
        const userData = this.props.rootUserData;
        if (!updateId) {
            console.warn('Update ID is null or undefined, not deleting update.');
            return;
        }
        const updateRef = realtimeDb.ref(`meldingen/${logEntry.id}/updates/${updateId}`);
        updateRef.update({
            invisible: true,
            invisibleAt: firebase.database.ServerValue.TIMESTAMP,
            invisibleBy: userData.uid,
        }).catch(error => {
            console.error('Error deleting update:', error);
        });

        showSnackbar('Verwijderd');
    }

    closeMeldingenDetailsModal = () => {
        this.setState({ showMeldingenDetailsModal: false, selectedMelding: null });
    }

    extendPostcode(postcode) {
        let extended = [];
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (let i = 0; i < 26; i++) {
            for (let j = 0; j < 26; j++) {
                extended.push(postcode + letters[i] + letters[j]);
            }
        }
        return extended;
    }

    saveMelding = async () => {
        const { userData, postalCodes, descriptionText, subjectText, location, addressText } = this.state;

        if (postalCodes.length === 0) {
            showSnackbarWithType('Voeg minimaal één postcode toe.', 'warning');
            return;
        }

        let addressComponents = addressText.split(' ');
        let twoLettersIndex = addressComponents.findIndex(part => /^[A-Za-z]{2}$/.test(part));

        postalCodes.push(addressComponents[twoLettersIndex - 1] + addressComponents[twoLettersIndex]);
        if (descriptionText.trim() === '') {
            showSnackbarWithType('Omschrijving is verplicht.', 'warning');
            return;
        }

        if (subjectText.trim() === '') {
            showSnackbarWithType('Onderwerp is verplicht.', 'warning');
            return;
        }

        const newMeldingRef = realtimeDb.ref('meldingen').push();
        const newMeldingId = newMeldingRef.key;

        const updatesWithPostalcodes = {};
        postalCodes.forEach(pc => {
            if (pc.length === 4) {
                // postcode needs to be extended to all combinations of AA to ZZ - like 1234AA, 1234AB, ..., 1234ZZ
                const extendedPostcodes = this.extendPostcode(pc);
                extendedPostcodes.forEach(epc => {
                    updatesWithPostalcodes[`${epc}/${newMeldingId}`] = firebase.database.ServerValue.TIMESTAMP;
                });

                updatesWithPostalcodes[`${pc}_mk/${newMeldingId}`] = firebase.database.ServerValue.TIMESTAMP;
            } else {
                updatesWithPostalcodes[`${pc.substring(0, 4)}_mk/${newMeldingId}`] = firebase.database.ServerValue.TIMESTAMP;
            }

            updatesWithPostalcodes[`${pc}/${newMeldingId}`] = firebase.database.ServerValue.TIMESTAMP;
        });

        const timestamp = Date.now();
        const newMelding = {
            id: newMeldingId,
            subject: subjectText,
            description: descriptionText,
            address: addressText,
            postalCodes: postalCodes,
            nearbyLocation: location,
            uid: userData.uid,
            status: 'open',
            timestamp: timestamp,
            updatedAt: timestamp,
        };

        console.log('newMelding:', newMelding);
        await realtimeDb.ref('meldingen').child(newMeldingId).set(newMelding)
            .then(() => {
                showSnackbar('Melding is opgeslagen.');
            });
            console.log('updatesWithPostalcodes:', updatesWithPostalcodes);
        await realtimeDb.ref(`meldingen_by_postalcodes`).update(updatesWithPostalcodes);

        const geofire = new GeoFire(realtimeDb.ref('meldingen_locations'));
        await geofire.set(newMeldingId, [location.lat, location.lng]);

        await realtimeDb.ref('meldingen_created_by_users').child(userData.uid).child(newMeldingId).set(firebase.database.ServerValue.TIMESTAMP);

        this.setState({ selectedMelding: null, showAddMeldingModal: false, postalCodes: [], descriptionText: '', subjectText: '', location: null, addressText: '' });
    }

    onClickMap = async event => {
        const lat = event.detail.latLng.lat;
        const lng = event.detail.latLng.lng;

        const geocoder = new window.google.maps.Geocoder();
        let jsonResult = await geocoder.geocode({ location: { lat, lng } });

        let findFirstAddressComponent = jsonResult.results.find(result => result.types.includes("street_address") || result.types.includes("route") || result.types.includes("point_of_interest"));
        let address = findFirstAddressComponent.formatted_address;
        // remove "Netherlands" from the address
        address = address.replace(/, Netherlands$/, '');
        // remove "Nederland" from the address
        address = address.replace(/, Nederland$/, '');

        this.setState({
            addressText: address,
            location: { lat, lng },
            address: address,
        });
    }

    render() {
        if (this.props.rootUserData && (!RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Wijkagent) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Gemeente) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Administrator))) {
            return (
                <div className="container content">
                    <div className="alert alert-danger" role="alert">
                        Je hebt geen toegang tot deze pagina.
                    </div>
                </div>
            );
        }

        return (
            <div className="container logboek  content" style={{ maxWidth: 1300 }}>

                {this.props.rootUserData && (
                    <button
                        type="button"
                        className="btn btn-primary btn-raised"
                        onClick={() => this.props.history.push({
                            pathname: '/workareas',
                            state: {}
                        })
                        }
                    >
                        Werkgebieden beheren
                    </button>
                )}
                {this.props.rootUserData && (
                    <button
                        style={{ marginLeft: 10 }}
                        type="button"
                        className="btn btn-primary btn-raised"
                        onClick={() => {
                            this.setState({ showAddMeldingModal: true, postalCodes: [], postalCodeInput: '', descriptionText: '', subjectText: '' });
                        }}>
                        + Nieuw melding
                    </button>
                )}
                <Table
                    style={{ width: '100%' }}
                    columns={this.state.columns}
                    data={this.state.logEntries}
                    stripe={true}
                    highlightCurrentRow={true}
                    height={600}
                    onCurrentChange={lastSelectedMelding => this.setState({ lastSelectedMelding })}
                />

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showAddMeldingModal}
                    onRequestClose={() => this.setState({ showAddMeldingModal: false })}
                    ariaHideApp={false}
                >
                    {this.state.showAddMeldingModal && (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title"><strong>Nieuwe melding plaatsen</strong></h4>
                                <button type="button" className="close" onClick={() => this.setState({ showAddMeldingModal: false })}>
                                    <span aria-hidden="true">&times;</span>
                                    <span className="sr-only">Annuleren</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="form-group">
                                    <label htmlFor="descriptionText">Onderwerp:</label>
                                    <select className="form-control" id="subjectText"
                                        style={{ border: "1px solid gray", padding: 6 }}
                                        value={this.state.subjectText}
                                        onChange={(e) => this.setState({ subjectText: e.target.value })}
                                    >
                                        <option value="" disabled>-- Selecteer een onderwerp --</option>
                                        {this.state.categories.map(category => (
                                            <option key={category.id} value={category.name}>{category.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="descriptionText">Omschrijving:</label>
                                    <textarea className="form-control" id="descriptionText" rows="2" placeholder="Omschrijving"
                                        style={{ border: "1px solid gray", padding: 6 }}
                                        value={this.state.descriptionText}
                                        onChange={(e) => this.setState({ descriptionText: e.target.value })}
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="descriptionText">Locatie: {this.state.addressText }</label>
                                    {this.state.mapLocation && (
                                        <AddMeldingMap
                                            location={this.state.mapLocation}
                                            meldingLocation={this.state.location}
                                            onClickMap={this.onClickMap}
                                        />
                                    )}
                                </div>

                                <span><strong>Huidige postcodes:</strong></span>
                                <div style={{ marginBottom: '1em' }}>
                                    {this.state.postalCodes && this.state.postalCodes.length > 0 ? (
                                        this.state.postalCodes.map((code, index) => (
                                            <span key={index} className="badge badge-primary" style={{ marginRight: '5px', cursor: 'pointer', padding: '0.5em', border: '1px solid rgb(221, 221, 221)' }}>
                                                {code} <span style={{ backgroundColor: 'rgb(240, 240, 240)', position: 'relative', padding: '5px', right: '-6px', color: 'rgb(72, 72, 72)' }} onClick={() => {
                                                    const updatedCodes = this.state.postalCodes.filter((_, i) => i !== index);
                                                    this.setState({ postalCodes: updatedCodes });
                                                }}>x</span>
                                            </span>
                                        ))
                                    ) : (
                                        <span className="badge badge-secondary">Geen postcodes toegevoegd</span>
                                    )}
                                </div>
                                <span><strong>Mijn opgeslagen werkgebieden (alleen met postcodes)</strong></span>
                                <div className="form-group" style={{ display: 'inline-flex', width: '100%', borderBottom: '1px solid #ddd', paddingBottom: '1em' }}>
                                    <div className="werkgebieden-list">
                                        {this.state.workareas && this.state.workareas.length > 0 ? (
                                            <ul className="list-group">
                                                {this.state.workareas.filter((v) => !v.geometry).map((item, index) => (
                                                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center" style={{ padding: 0 }}>
                                                        <span>{item.label && item.label + ":"} {item.postcodes && item.postcodes.map((code, index) => (
                                                            <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                                                {code}
                                                            </span>
                                                        ))}</span>
                                                        <button className="btn btn-primary btn-sm btn-outline" onClick={() => {
                                                            const updatedCodes = [...this.state.postalCodes, ...item.postcodes];
                                                            const uniqueCodes = [...new Set(updatedCodes)];
                                                            this.setState({ postalCodes: uniqueCodes });
                                                        }}>Toevoegen</button>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p>Geen werkgebieden gevonden.</p>
                                        )}
                                    </div>
                                </div>
                                <p>Voer een postcode in (1234AB - letters optioneel voor kleiner bereik)</p>
                                <div className="form-group" style={{ display: 'inline-flex', width: '100%' }}>
                                    <input type="text" style={{ maxWidth: '300px', marginRight: '12px' }} className="form-control" placeholder="Postcode" value={this.state.postalCodeInput} onChange={(e) => this.setState({ postalCodeInput: e.target.value })} />
                                    <button type="button" className="btn btn-primary btn-outline" onClick={() => {
                                        const { postalCodes, postalCodeInput } = this.state;

                                        if (postalCodes.includes(postalCodeInput.trim())) {
                                            showSnackbarWithType('Deze postcode is al toegevoegd.', 'warning');
                                            return;
                                        } else if (postalCodeInput.trim() === '') {
                                            showSnackbarWithType('Voer een geldige postcode in.', 'warning');
                                            return;
                                        } else if (postalCodeInput.trim().length < 4 || postalCodeInput.trim().length > 6) {
                                            showSnackbarWithType('Postcode moet tussen de 4 en 6 karakters zijn.', 'warning');
                                            return;
                                        }

                                        if (postalCodeInput.trim() !== '') {
                                            this.setState({
                                                postalCodes: [...postalCodes, postalCodeInput.trim()],
                                                postalCodeInput: ''
                                            });
                                        }
                                    }}>
                                        Voeg postcode toe
                                    </button>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showAddMeldingModal: false })}>Sluiten</button>
                                <button type="button" className="btn btn-primary btn-raised" onClick={() => this.saveMelding()}>Opslaan</button>
                            </div>
                        </div>
                    )}
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalUpdateLogStatusIsOpen}
                    onRequestClose={this.closeUpdateLogStatusModal}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Status wijzigen</h4>
                            <button type="button" className="close" onClick={this.closeUpdateLogStatusModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span>Weet je zeker dat je de status wilt veranderen naar {this.state.newStatus}?</span>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeUpdateLogStatusModal}>Annuleren</button>
                            <button type="button" className="btn btn-primary btn-outline" onClick={this.handleUpdateLogStatusModal}>Opslaan</button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalDeleteLogIsOpen}
                    onRequestClose={this.closeDeleteLogModal}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Melding verwijderen</h4>
                            <button type="button" className="close" onClick={this.closeDeleteLogModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span>Weet je zeker dat je deze melding wilt verwijderen? Het verwijderen van een melding is definitief en niet mogelijk om te herstellen.</span>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeDeleteLogModal}>Annuleren</button>
                            <button type="button" className="btn btn-danger btn-outline" onClick={this.handleDeleteLogClicked}>Verwijderen</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }

    // Mark the specified log as marked
    updateStatus = (log, status) => {
        if (status !== "gesloten") {
            realtimeDb.ref(`meldingen/${log.id}/closingMessage`).set(null);
        }

        realtimeDb.ref(`meldingen/${log.id}/status`).set(status)
            .then(() => {
                showSnackbar('Status is nu ' + status);
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
                showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
            });
    }

    renderProcessButton = (log) => {
        return (
            <td>
                {log.status !== 'gesloten' ? (
                    <button className="btn btn-success" title="Gesloten" data-toggle="tooltip"
                        onClick={() => {
                            this.openUpdateLogStatusModal(log, 'gesloten');
                        }}><i className="material-icons">done</i>
                    </button>
                ) : (
                    <button className="btn btn-warning" title="Open" data-toggle="tooltip"
                        onClick={() => {
                            this.openUpdateLogStatusModal(log, 'open');
                        }}><i className="material-icons">undo</i>
                    </button>
                )}
            </td>

        );
    }

    openUpdateLogStatusModal = (lastSelectedMelding, newStatus) => {
        this.setState({ modalUpdateLogStatusIsOpen: true, lastSelectedMelding, newStatus });
    }
    closeUpdateLogStatusModal = () => {
        this.setState({ modalUpdateLogStatusIsOpen: false, lastSelectedMelding: null, newStatus: null });
    }
    handleUpdateLogStatusModal = () => {
        this.updateStatus(this.state.lastSelectedMelding, this.state.newStatus);
        this.closeUpdateLogStatusModal();
    }

}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(Meldingen);
